<template>
    <el-input type="text"
              pattern="^\/[0-9A-Z.+-]{7}$"
              placeholder="+新增"
              :maxlength="8"
              v-model="vModel"
              class="no-border e-invoice mobile-barcode"/>
</template>

<script>
    export default {
        name: "MobileBarcode",
        props: ["value"],
        data() {
            return {
                vModel: this.value,
            }
        },
        created() {

        },
        mounted() {

        },
        watch:{
            vModel: {
              handler:function (newVal,oldVal) {
                this.$emit('update',newVal);
              },
              deep : true ,
              immediate : true,
            },
        },
    }
</script>
